import { getIntDate } from '@/views/analysis/common.js'
export default {
  titleTxt: [
    {
      title: '内容列表',
      tipTxt: '您可以查看满足选定的查询条件以及时间周期内具体的内容信息。点击具体内容，可以查看原始页面内容。'
    }
  ],
  filterAjaxList: [
    {
      url: '/api/label/brand/label',
      method: 'post',
      param: {},
      flagKey: 'brand',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/line/label',
      method: 'get',
      flagKey: 'lineName',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/platform/label',
      method: 'post',
      param: {},
      flagKey: 'platform',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/index/label',
      method: 'get',
      param: {},
      flagKey: 'index',
      id: 'labelName',
      name: 'name'
    },
    {
      url: '/api/label/brand/label',
      method: 'post',
      param: {},
      flagKey: 'target',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/is/prereport/label',
      method: 'get',
      flagKey: 'isPrereport',
      id: 'name',
      name: 'name'
    }
  ],
  filterForm: [
    {
      type: 'select',
      clearable: true,
      id: 'platform',
      label: '平台',
      width: '250px',
      intintValue: '',
      children: []
    }, {
      type: 'select',
      clearable: true,
      id: 'brand',
      label: '品牌',
      width: '250px',
      intValue: '',
      children: []
    }, {
      type: 'select',
      clearable: true,
      id: 'lineName',
      label: '产线',
      placeholder: '综合',
      width: '250px',
      intintValue: '',
      children: []
    }, {
      type: 'tab',
      id: 'timeType',
      label: '选择时间',
      intValue: '0',
      children: [{
        id: '0',
        name: '月报',
        showItemId: 'dateMonth',
        hideItemId: 'dateTime'
      }, {
        id: '1',
        name: '日报',
        showItemId: 'dateTime',
        hideItemId: 'dateMonth'
      }]
    }, {
      type: 'month',
      isHide: false,
      format: 'yyyy年 MM月',
      valueFormat: 'yyyy-MM',
      clearable: true,
      id: 'dateMonth',
      label: '',
      width: '180px',
      // intValue: '2021-12'
      intValue: getIntDate()
    }, {
      type: 'datesRange',
      dateType: 'date',
      isHide: true,
      clearable: true,
      id: 'dateTime',
      startTimeId: 'dateTimeStartTime',
      endTimeId: 'dateTimeEndTime',
      label: '',
      width: '390px',
      intValue: ['', '']
    },
    {
      type: 'select',
      id: 'isPrereport',
      label: '是否报备',
      placeholder: '全部',
      width: '250px',
      intintValue: '',
      children: []
    },
    {
      type: 'select',
      id: 'isPopular',
      label: '是否爆款',
      width: '250px',
      intValue: '',
      placeholder: '全部',
      children: [
        {
          id: 1,
          name: '是'
        },
        {
          id: 0,
          name: '否'
        }
      ]
    }, {
      type: 'select',
      clearable: true,
      id: 'index',
      label: '选择指标',
      width: '250px',
      intValue: '',
      children: []
    }, {
      type: 'select',
      id: 'target',
      label: '对比品牌',
      width: '250px',
      intValue: '',
      children: []
    }
  ],
  formRules: {
    brand: [
      {
        required: true,
        message: '请选择'
      }
    ]
  },
  barList: [
    {
      name: '内容类型',
      tipTxt: '在选定的查询条件以及时间周期内，您可以了解各个内容类型的指标统计情况，也可以加入竞品数据进行对比分析。<br />内容类型包括：测评、好物推荐、选购、横评、使用体验等。',
      id: 'user-origin-column-chart',
      type: 1,
      isLoading: false,
      isNodata: false
    }, {
      name: '内容场景',
      tipTxt: '在选定的查询条件以及时间周期内，您可以了解各个内容场景的指标统计情况，也可以加入竞品数据进行对比分析。<br />内容场景包括：门店、真实用户、伪真实用户、素材剪辑',
      id: 'content-scene-column-chart',
      type: 2,
      isLoading: false,
      isNodata: false
    }, {
      name: '内容选题',
      tipTxt: '在选定的查询条件以及时间周期内，您可以了解各个内容选题的指标统计情况，也可以加入竞品数据进行对比分析。<br />内容选题包括：双方共创、达人原创、品牌方规定、平台热点等。',
      id: 'topic-column-chart',
      type: 3,
      isLoading: false,
      isNodata: false
    }, {
      name: '内容封面',
      tipTxt: '在选定的查询条件以及时间周期内，您可以了解各个内容封面类型的指标统计情况，也可以加入竞品数据进行对比分析。<br />内容封面包括：门店、厨房、房间、客厅、人物、美食、产品、花字等。',
      id: 'cover-column-chart',
      type: 4,
      isLoading: false,
      isNodata: false
    }
  ],
  seriesData: [
    {
      name: '方太',
      type: 'bar',
      data: [],
      itemColor: '#FFC750',
      emphasisColor: '#FFB600',
      key: 'indicator'
    }, {
      name: '火星人',
      type: 'bar',
      data: [],
      itemColor: '#326CFA',
      emphasisColor: '#326CFA',
      key: 'addCompare'
    }
  ],
  userOriginList: [
    {
      dataTime: '测评',
      indicator: '100',
      addCompare: 210
    },
    {
      dataTime: '好物推荐',
      indicator: '120',
      addCompare: 123
    },
    {
      dataTime: '选购',
      indicator: '300',
      addCompare: 358
    },
    {
      dataTime: '横评',
      indicator: '243',
      addCompare: 144
    },
    {
      dataTime: '使用体验',
      indicator: '125',
      addCompare: 83
    }
  ],
  sortRules: [{
    name: '降序',
    id: '1'
  }, {
    name: '升序',
    id: '2'
  }],
  // 内容列表数据 - 表头
  tableHead: [
    {
      label: '序号',
      key: '$index',
      width: '60',
      fixed: true
    }, {
      label: '标题',
      key: 'title',
      fixed: true,
      isLink: true,
      linkKey: 'url'
    }, {
      label: '发布链接',
      key: 'url',
      fixed: true,
      isLink: true,
      linkKey: 'url'
    }, {
      label: '发布时间',
      key: 'pubTime',
      width: '150',
      fixed: true
    }, {
      label: '产线',
      key: 'lineName',
      fixed: true
    }, {
      label: '产品型号',
      key: 'lineType',
      width: 180
    }, {
      label: '品牌',
      key: 'brand'
    }, {
      label: '平台',
      key: 'platform'
    }, {
      label: '费用成本(元)',
      key: 'totalCost',
      txtAlign: 'right',
      rightWidth: '180px'
    }, {
      label: '搜索信息流花费(元)',
      key: 'searchCost',
      txtAlign: 'right',
      rightWidth: 180
    }, {
      label: '品牌广告花费(元)',
      key: 'brandAdCost',
      txtAlign: 'right',
      rightWidth: 180
    }, {
      label: '合作价格(元)',
      key: 'cooperateCost',
      txtAlign: 'right',
      rightWidth: '150px'
    }, {
      label: '是否爆款',
      key: 'isPopular',
      txtAlign: 'right'
    }, {
      label: '曝光数',
      key: 'exposeNum',
      txtAlign: 'right'
    }, {
      label: '阅读量',
      key: 'readNum',
      txtAlign: 'right'
    }, {
      label: '点赞量',
      key: 'likeNum',
      txtAlign: 'right'
    }, {
      label: '收藏量',
      key: 'subscribeNum',
      txtAlign: 'right'
    }, {
      label: '评论量',
      key: 'commentNum',
      txtAlign: 'right'
    }, {
      label: '完播率',
      key: 'finishRate',
      txtAlign: 'right'
    }, {
      label: '互动量',
      key: 'interactNum',
      txtAlign: 'right'
    }, {
      label: '互动率',
      key: 'interactRate',
      txtAlign: 'right'
    }, {
      label: '互动成本(元)',
      key: 'interactCost',
      txtAlign: 'right',
      rightWidth: '150px'
    }, {
      label: '互动成本层级',
      key: 'interactCostLevel'
    }, {
      label: 'CPE(元)',
      key: 'cpeCost',
      txtAlign: 'right'
    }, {
      label: 'CPV(元)',
      key: 'cpvCost',
      txtAlign: 'right'
    }, {
      label: '内容类型',
      key: 'contentType'
    }, {
      label: '内容选题',
      key: 'theme'
    }, {
      label: '合作形式',
      key: 'cooperateType'
    }, {
      label: '封面',
      key: 'cover'
    }, {
      label: '拍摄场景',
      key: 'scene'
    }, {
      label: '产品卖点',
      key: 'sellPoint'
    }, {
      label: '产品露出占比',
      key: 'productExposeRate',
      txtAlign: 'right',
      rightWidth: 150
    }, {
      label: '达人名称',
      key: 'authName'
    }, {
      label: '地域',
      key: 'authArea'
    }, {
      label: '粉丝数(万)',
      key: 'follower'
    }, {
      label: '粉丝量级',
      key: 'followerLevel'
    }, {
      label: '获赞与收藏量(万)',
      key: 'authLikeCollcet',
      txtAlign: 'right',
      rightWidth: 180
    }, {
      label: '达人量级',
      key: 'authLevel'
    }, {
      label: '达人圈层',
      key: 'authCircle'
    }, {
      label: '是否报备',
      key: 'isPrereport'
    }, {
      label: '是否有个人使用经验',
      key: 'hasPersonalOpinion',
      width: 160
    }, {
      label: '是否收录',
      key: 'isCollect'
    }, {
      label: '讨论关键词',
      key: 'commentKeyword'
    }, {
      label: '竞品负面评论数',
      key: 'competitorNegativeCommentNum',
      txtAlign: 'right',
      rightWidth: '180px'
    }, {
      label: '竞品正面及中性评论数',
      key: 'competitorPositiveCommentNum',
      txtAlign: 'right',
      rightWidth: '220px'
    }, {
      label: '我方正面及中性评论数',
      key: 'positiveCommentNum',
      txtAlign: 'right',
      rightWidth: '220px'
    }, {
      label: '我方负面评论数',
      key: 'negativeCommentNum',
      txtAlign: 'right',
      rightWidth: '180px'
    }
  ]
}
